import actions from "./actions";

export default {
  namespaced: true,
  state: {
    showcases: []
  },
  mutations: {
    setShowcases(state, showcases) {
      state.showcases = showcases;
    }
  },
  actions
};
